import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollOnNavigation = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // When the URL carries a hash (e.g. /faq#general) the destination page is
    // responsible for scrolling to that anchor — don't yank the view to the top.
    if (hash) {
      return;
    }

    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [pathname, hash]);

  return null;
};

export default ScrollOnNavigation;
